import { categoryRepository } from '~/api/repository/category';

export const CATEGORY_QUERY_KEY = {
  all: ['category'] as const,

  // 전시 카테고리 트리 조회 (useOAIQuery와 동일한 queryKey 사용)
  tree: () => ({
    queryKey: ['/api/market-place/v1/display-categories'] as const,
    queryFn: () => categoryRepository.getCategoryTree(),
  }),

  // 특정 카테고리의 하위(descendants) 트리 조회
  descendants: (displayCategoryId: number) => ({
    queryKey: [
      '/api/market-place/v1/display-categories/{displayCategoryId}/descendants',
      displayCategoryId,
    ] as const,
    queryFn: () => categoryRepository.getCategoryDescendants(displayCategoryId),
  }),

  // 벤더 전시 카테고리 조회 (ancestorId: 3depth 탭 / vendorId: 입점사 스코프)
  vendor: (params: { ancestorId?: number; vendorId?: number }) => ({
    queryKey: [
      '/api/market-place/v1/display-categories/vendor',
      params,
    ] as const,
    queryFn: () => categoryRepository.getVendorCategories(params),
  }),
};
